<template>
  <div class="flex flex-col items-center justify-center pt-24 pb-32 px-4">
    <img class="w-12 h-12 mb-4 animate-spin-slow" :src="require('../../images/loading.svg')">
  </div>
</template>
